import Carousel from 'react-bootstrap/Carousel';
import React, { useEffect, useRef, useState } from 'react';
import './partners.css';

const partnersData = [
  {
    id: 1,
    logo: require('../../../assets/logo-lusofona.jpg'),
    name: 'Universidade Lusófona',
    link: 'https://www.ulusofona.pt/'
  },
  {
    id: 2,
    logo: require('../../../assets/logo-isced.jpg'),
    name: 'Instituto Superior da Ciência da Educação',
    link: 'https://isced.ed.ao/'
  },
  {
    id: 3,
    logo: require('../../../assets/logo-evora.png'),
    name: 'Universidade de Évora',
    link: 'https://www.uevora.pt/'
  },
  {
    id: 4,
    logo: require('../../../assets/logo-lusofona.jpg'),
    name: 'Universidade Lusófona',
    link: 'https://www.ulusofona.pt/'
  },
  {
    id: 5,
    logo: require('../../../assets/logo-isced.jpg'),
    name: 'Instituto Superior da Ciência da Educação',
    link: 'https://isced.ed.ao/'
  },
  {
    id: 6,
    logo: require('../../../assets/logo-evora.png'),
    name: 'Universidade Lusófona',
    link: 'https://www.uevora.pt/'
  }
];

function PartnersCarousel() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Dividir os parceiros em grupos para exibir vários por slide
  const groupSize = 3;
  const partnerGroups = [];
  for (let i = 0; i < partnersData.length; i += groupSize) {
    partnerGroups.push(partnersData.slice(i, i + groupSize));
  }

  return (
    <section 
      id="partners" 
      className="partners-block"
      ref={sectionRef}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(30px)',
        transition: 'opacity 0.6s ease-out, transform 0.6s ease-out'
      }}
    >
      <div className="container">
        <div className="title-wrapper" style={{
          animation: visible ? 'fadeInUp 0.8s ease-out' : 'none'
        }}>
          <h2 className="section-title">
            <span className="title-text">Nossos Parceiros</span>
            <span className="title-underline"></span>
          </h2>
          <p className="section-subtitle">
            Instituições que colaboram com nossa missão educacional
          </p>
        </div>

        <div style={{
          animation: visible ? 'fadeIn 1s ease-out 0.3s both' : 'none'
        }}>
          <Carousel 
            indicators={partnerGroups.length > 1} 
            controls={partnerGroups.length > 1}
            interval={10000}
            pause={false}
            fade={false}
            wrap={true}
          >
            {partnerGroups.map((group, index) => (
              <Carousel.Item key={index}>
                <div className="partner-logos-container">
                  {group.map(partner => (
                    <a 
                      key={partner.id} 
                      href={partner.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="partner-logo-link"
                    >
                      <img
                        src={partner.logo}
                        alt={partner.name}
                        className="partner-logo"
                        title={partner.name}
                      />
                    </a>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
}

export default PartnersCarousel;